import { useCallback } from 'react'
import { SearchList01Icon } from '@hugeicons/core-solid-rounded'
import { useLocation } from 'wouter'
import { useLingui } from '@lingui/react/macro'
import { GraphQL } from '@guestgoodie/graphql'

import Input from '@/components/ui/Input'
import { AddButton } from '@/components/ui/IconButton'
import FilterSelect from '@/components/ui/FilterSelect'
import { helpers, StayTable, useStayTable } from '@/features/stay'
import { SyncButton, useIsPmsConnected } from '@/features/integrations'

import {
  CheckPermission,
  Permission,
  useCheckPermission
} from '@/features/auth'

function Stays() {
  const { t } = useLingui()
  const stateOptions = helpers.useStateOptions()

  const isConnected = useIsPmsConnected()
  const hasPermissionToCreate = useCheckPermission([Permission.STAY_CREATE])
  const canCreate = !isConnected && hasPermissionToCreate

  const { queryVariables, states, search, setSearch, setStates, updateSort } =
    useStayTable()

  const [, navigate] = useLocation()

  const onAddNewStay = useCallback(() => {
    navigate('/create-stay')
  }, [navigate])

  return (
    <CheckPermission permissions={[Permission.STAY_READ]} redirect="/goodies">
      <main className="flex flex-col pr-5">
        <div className="flex w-full flex-col md:flex-row gap-2.5 pt-1 pb-6 items-start md:items-center">
          <div className="flex flex-row gap-2.5 items-center">
            {canCreate && (
              <AddButton onClick={onAddNewStay} aria-label={t`Create Stay`} />
            )}
            <SyncButton type={GraphQL.SyncableObject.Stays} />
            <FilterSelect
              options={stateOptions}
              selectedValues={states}
              onChange={setStates}
              placeholder={t`All states`}
            />
          </div>
          <div className="self-end">
            <Input
              Icon={SearchList01Icon}
              value={search}
              placeholder={t`Search…`}
              onChange={event => setSearch(event.target.value)}
            />
          </div>
        </div>
        <div className="relative w-full rounded bg-white p-5 flex-1 overflow-hidden flex flex-col">
          <div className="size-full overflow-y-auto inset-0">
            <StayTable variables={queryVariables} onChangeSort={updateSort} />
          </div>
        </div>
      </main>
    </CheckPermission>
  )
}

export default Stays
